import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { catchError, Observable, of } from 'rxjs';

import { BnInternalHeaders } from '@bn/primitives';

import { ContentSlide } from '../models/sliders/content-slide.model';
import { RegisterSlide } from '../models/sliders/register-slide.model';
import { Trustpilot } from '../models/sliders/trustpilot.model';
import { AUTH_SLIDES_ENABLED } from '../tokens/auth-slides.token';

@Injectable({
  providedIn: 'root',
})
export class AuthSliderService {
  readonly #httpClient = inject(HttpClient);
  readonly #slidesEnabled = inject(AUTH_SLIDES_ENABLED);
  #apiUrl: string;

  constructor() {
    this.#apiUrl = `${window.location.origin}/data`;
  }

  public getTrustpilotData(): Observable<Trustpilot | null> {
    if (!this.#slidesEnabled) return of(null);

    return this.#httpClient.get<Trustpilot>(`${this.#apiUrl}/trustpilot.json`);
  }

  public get2FASlides(): Observable<ContentSlide[]> {
    if (!this.#slidesEnabled) return of([]);

    return this.#httpClient.get<ContentSlide[]>(`${this.#apiUrl}/slides-2fa.json`);
  }

  public getLoginSlides(): Observable<ContentSlide[]> {
    if (!this.#slidesEnabled) return of([]);

    return this.#httpClient.get<ContentSlide[]>(`${this.#apiUrl}/slides-login.json`);
  }

  public getRegisterSlides(tenantId: string, version = ''): Observable<RegisterSlide | null> {
    if (!this.#slidesEnabled) return of(null);

    // fallback version = 1
    const tenantPath = tenantId ? `tenants/${tenantId}/` : '';
    const versionSuffix = version.length ? version.toLowerCase() : '1';
    const filename = `${this.#apiUrl}/${tenantPath}slides-register-${versionSuffix}.json`;

    return this.#httpClient
      .get<RegisterSlide>(filename, {
        headers: {
          [BnInternalHeaders.IgnoreErrorToast]: 'true',
        },
      })
      .pipe(catchError(() => of(null)));
  }

  public getResetPasswordSlides(): Observable<ContentSlide[]> {
    if (!this.#slidesEnabled) return of([]);

    return this.#httpClient.get<ContentSlide[]>(`${this.#apiUrl}/slides-resetpassword.json`);
  }
}
